<template>
  <SbDropdownSeparator />
</template>

<script lang="ts" setup>
import { SbDropdownSeparator } from '../Dropdown'
</script>
